<ng-container *ngIf="notification" class="content">
  <p
    *ngIf="notification?.title === 'Actualiza tus datos'"
    appReplaceWordWithLink
    [wordToReplace]="'Mi perfil'"
    [linkPath]="'/private-area/personal-data'"
    [redirect]="redirect"
    class="content__paragraph">
    {{ notification.text }}
  </p>

  <p
    *ngIf="notification?.title === 'Documento de identidad caducado' || notification?.title === 'Actualiza tu documento de identidad'"
    appReplaceWordWithLink
    [wordToReplace]="notification?.title === 'Documento de identidad caducado' ? 'aquí' : 'aquí'"
    [linkPath]="'/private-area/documentation'"
    [redirect]="redirect"
    class="content__paragraph">
    {{ notification.text }}
  </p>

  <p
    *ngIf="notification?.title === 'Documentación pendiente de aportar'"
    appReplaceWordWithLink
    [wordToReplace]="'Mis documentos'"
    [linkPath]="'/private-area/documentation'"
    [redirect]="redirect"
    class="content__paragraph">
    {{ notification.text }}
  </p>

  <p  *ngIf="notification?.title === 'Documentación pendiente por firmar'">
    {{ notification.text }}
  </p>
</ng-container>
